export default __webpack_public_path__ + "static/media/BookTracker.c693ac2a.jpg";